import { BaseViewStore } from 'core/stores';
import { action, makeObservable, observable } from 'mobx';
import _ from 'lodash';
import { ProductInventoryStore } from 'modules/product-inventory/stores';
import { isSeller, isSome, isWarehouse } from 'core/utils';
import { BaasicDropdownViewStore } from 'common/stores';
import { ApplicationStore } from 'platform/application/stores';
import { isSuperAdminOrganization } from 'core/utils';
import { ExportInventoryByDateForm } from '../forms';
import moment from 'moment';

class ExportInventoryByDateModalViewStore extends BaseViewStore {
	@observable isSyncing = false;
	@observable sellerDropdownStore = null;
	@observable defaultSellerValue = null;

	form = new ExportInventoryByDateForm({
		onSuccess: async () => {
			await this.exportInventory();
		},
	});

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.data = modalParams && modalParams.data ? modalParams.data : null;
		this.productInventoryStore = new ProductInventoryStore(this.rootStore);
		this.initialize();
	}

	@action.bound
	initialize = async () => {
		this.suspend();
		this.isSuperAdminOrganization = isSuperAdminOrganization(this.rootStore);
		this.isSeller = isSeller(this.rootStore);
		this.isWarehouse = isWarehouse(this.rootStore);
		await this.setDefaultSellerValue();
		this.sellerDropdownStore = new BaasicDropdownViewStore();
		await this.sellerDropdownStore.initialize({
			field: this.form.$('sellerId'),
			value: this.defaultSellerValue,
			store: new ApplicationStore(this.rootStore),
			itemTemplate: {
				value: 'id',
				label: 'applicationTitle',
			},
			filterProperties: {
				sellerOnly: true,
				embed: ['organizationType'],
			},
		});
		this.form.$('date').set('value', moment().subtract(1, 'days').format(moment.localeData().longDateFormat('L')));
		this.resume();
	};

	@action.bound
	exportInventory = async () => {
		const notificationId = this.rootStore.notificationStore.load("Exporting inventory...");
		const sellerId = isSome(this.sellerDropdownStore.value) ? this.sellerDropdownStore.value.value : null;
		const date = this.form.$('date').value;
		
		try {
			const response = await this.productInventoryStore.exportInventoryByDate(
				{ sellerId, date },
				'Inventory List - Export Inventory by Date'
			);
	
			this.rootStore.notificationStore.dismiss(notificationId);
	
			if (response.statusCode === 200)  {
				const binaryData = atob(response.data.file);
				const uint8Array = new Uint8Array(binaryData.length);
				for (let i = 0; i < binaryData.length; i++) {
					uint8Array[i] = binaryData.charCodeAt(i);
				}
				const blob = new Blob([uint8Array], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				})
				const fileName = `Inventory_${moment(date).format('YYYYMMDD')}.xlsx`;
				saveAs(blob, fileName);
				this.rootStore.notificationStore.success('Inventory export successful.');
			}
			else
				this.rootStore.notificationStore.error('Inventory export failed.');
		}
		catch (error) {
			this.rootStore.notificationStore.dismiss(notificationId);
			this.rootStore.notificationStore.error('An error occurred while exporting inventory.');
		}
	}

	@action.bound
	setDefaultSellerValue = async () => {
		if (this.isSuperAdminOrganization || this.isWarehouse) {
			this.defaultSellerValue = this.rootStore.viewStore.sellerDropdownStore.value;
		}
		else if (this.isSeller) {
			this.defaultSellerValue = this.rootStore.applicationStore.currentOrganization;
		}
	}

	@action.bound
	isDateValid = () => {
		return moment(this.form.$('date').value, moment.localeData().longDateFormat('L'), true).isValid();
	}
}

export default ExportInventoryByDateModalViewStore;
